import {Component} from '@angular/core';

@Component({
  selector: 'voice-mail-ico',
  templateUrl: './voice-mail-ico.component.html'
})
export class VoiceMailIcoComponent {
}
